(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["coverflow-video"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function debounce(fn, ms) {
    var t;
    return function () { clearTimeout(t); t = setTimeout(fn, ms); };
  }

  class CoverflowVideo extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;

      this.stage = this.querySelector('[data-cv-stage]');
      this.cards = Array.prototype.slice.call(this.querySelectorAll('[data-cv-card]'));
      this.prevBtn = this.querySelector('[data-cv-prev]');
      this.nextBtn = this.querySelector('[data-cv-next]');
      this.live = this.querySelector('[data-cv-live]');
      this.n = this.cards.length;
      if (!this.n || !this.stage) return;

      this.active = 0;
      this.inView = true;
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (this.reduced) this.classList.add('cv-reduced');

      this.opts = {
        autoplay: this.dataset.autoplayCenter !== 'false',
        loop: this.dataset.loop !== 'false',
        clickCenter: this.dataset.clickCenter !== 'false',
        autorotate: this.dataset.autorotate === 'true',
        interval: (parseInt(this.dataset.interval, 10) || 5) * 1000,
        sideCards: parseInt(this.dataset.sideCards, 10) || 2
      };

      this.bind();
      this.layout();
      this.observe();
      this._onResize = debounce(this.layout.bind(this), 150);
      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      if (this._onResize) window.removeEventListener('resize', this._onResize);
      if (this._io) this._io.disconnect();
      if (this._onKeydown) this.removeEventListener('keydown', this._onKeydown);
      this.stopAuto();
    }

    bind() {
      var self = this;
      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { self.go(-1); });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.go(1); });

      this.cards.forEach(function (card, i) {
        card.addEventListener('click', function () {
          if (i === self.active) {
            var link = card.getAttribute('data-cv-link');
            if (link) window.location.href = link;
          } else if (self.opts.clickCenter) {
            self.setActive(i);
          }
        });
        var unmute = card.querySelector('[data-cv-unmute]');
        if (unmute) unmute.addEventListener('click', function (e) { e.stopPropagation(); self.toggleMute(card, unmute); });
        var play = card.querySelector('[data-cv-play]');
        if (play) play.addEventListener('click', function (e) {
          e.stopPropagation();
          card.classList.add('cv-playing');
          var v = card.querySelector('.cv__video');
          if (v) { if (!v.src && v.dataset.src) { v.src = v.dataset.src; v.load(); } var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        });
        var cta = card.querySelector('.cv__cta');
        if (cta) cta.addEventListener('click', function (e) { e.stopPropagation(); });
      });

      this._onKeydown = function (e) {
        if (e.key === 'ArrowLeft') { e.preventDefault(); self.go(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); self.go(1); }
        else if (e.key === 'Enter') {
          var link = self.cards[self.active].getAttribute('data-cv-link');
          if (link) window.location.href = link;
        }
      };
      this.addEventListener('keydown', this._onKeydown);

      // touch swipe
      var sx = 0, sy = 0;
      this.stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      this.stage.addEventListener('touchend', function (e) {
        var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) self.go(dx < 0 ? 1 : -1);
      }, { passive: true });

      if (this.opts.autorotate && !this.reduced) {
        this.addEventListener('mouseenter', function () { self.stopAuto(); });
        this.addEventListener('mouseleave', function () { self.startAuto(); });
        this.addEventListener('focusin', function () { self.stopAuto(); });
        this.addEventListener('focusout', function () { self.startAuto(); });
      }

      if (window.Shopify && window.Shopify.designMode) {
        this.addEventListener('shopify:block:select', function (e) {
          var card = e.target.closest('[data-cv-card]');
          var idx = self.cards.indexOf(card);
          if (idx >= 0) self.setActive(idx);
        });
      }
    }

    sideCount() {
      var w = window.innerWidth;
      if (w < 768) return 1;
      if (w < 1200) return Math.min(1, this.opts.sideCards);
      return this.opts.sideCards;
    }

    offsetFor(i) {
      var off = i - this.active;
      if (this.opts.loop) {
        if (off > this.n / 2) off -= this.n;
        if (off < -this.n / 2) off += this.n;
      }
      return off;
    }

    layout() {
      // Use the unzoomed CSS var (the theme may apply a desktop `zoom`, which
      // would scale getBoundingClientRect and skew the spread ratio + height).
      var cardW = parseInt(getComputedStyle(this).getPropertyValue('--cv-card-w'), 10) || 360;
      var side = this.sideCount();
      var spread = window.innerWidth < 768 ? 0.46 : 0.55;
      var self = this;

      this.cards.forEach(function (card, i) {
        var off = self.offsetFor(i);
        var a = Math.abs(off);
        var scale, opacity, rotate, tz;
        if (a === 0) { scale = 1; opacity = 1; rotate = 0; tz = 0; }
        else if (a === 1) { scale = 0.82; opacity = 1; rotate = 10; tz = -120; }
        else if (a === 2) { scale = 0.64; opacity = 1; rotate = 16; tz = -240; }
        else { scale = 0.5; opacity = 0; rotate = 18; tz = -340; }
        if (a > side) opacity = 0; // only fully off-stage cards are hidden
        var x = off * cardW * spread;
        var ry = off > 0 ? -rotate : (off < 0 ? rotate : 0);
        card.style.transform = 'translateX(calc(-50% + ' + x + 'px)) translateZ(' + tz + 'px) rotateY(' + ry + 'deg) scale(' + scale + ')';
        card.style.opacity = opacity;
        card.style.zIndex = String(100 - a);
        card.style.pointerEvents = a > side ? 'none' : 'auto';
        var isActive = off === 0;
        card.classList.toggle('is-active', isActive);
        card.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        if (!isActive) card.classList.remove('cv-playing');
      });

      // Stage height comes from the CSS min-height (var(--cv-card-h)); no JS
      // override needed, which also avoids a CLS shift and zoom double-scaling.

      this.loadNeighbors();
      this.playActive();
      this.announce();
    }

    setActive(i) {
      this.active = ((i % this.n) + this.n) % this.n;
      this.layout();
    }
    go(dir) { this.setActive(this.active + dir); }

    loadNeighbors() {
      if (this.reduced) return; // reduced motion: stay on posters until play
      var self = this;
      var side = this.sideCount();
      this.cards.forEach(function (card, i) {
        var a = Math.abs(self.offsetFor(i));
        if (a <= side) self.ensureLoaded(card, a === 0); // active full, neighbours first-frame
      });
    }

    // Load a card's video. Every loaded card (active AND side cards) preloads
    // enough to paint its first frame so it's always visible — never a blank
    // tile. `full` (active) keeps buffering for playback; side cards freeze on
    // the first frame, then downgrade preload to stop buffering the whole clip.
    ensureLoaded(card, full) {
      var v = card.querySelector('.cv__video');
      if (!v) return;
      if (v.dataset.src && !v.src) {
        v.preload = 'auto'; // 'metadata' alone may never reach a paintable frame
        v.src = v.dataset.src;
        v.load();
        v.addEventListener('loadeddata', function () {
          v.classList.add('cv-ready');
          // Browsers won't paint a frame for a never-played paused <video>. For
          // side cards, play then pause AFTER the first frame is actually
          // composited so it freezes on a real frame. `freezing` tells
          // playActive not to interrupt mid-paint.
          if (!full) {
            v.dataset.freezing = '1';
            var done = function () { try { v.pause(); } catch (e) {} v.preload = 'metadata'; delete v.dataset.freezing; };
            var pr = v.play();
            // Let it play long enough for the compositor to actually paint a
            // frame (a too-quick pause leaves the surface blank), then freeze.
            if (pr && pr.catch) pr.catch(function () { delete v.dataset.freezing; });
            setTimeout(done, 400);
          }
        }, { once: true });
      } else if (v.readyState >= 2) {
        v.classList.add('cv-ready');
      }
    }

    playActive() {
      var self = this;
      this.cards.forEach(function (card, i) {
        var v = card.querySelector('.cv__video');
        if (!v) return;
        if (i === self.active) {
          if (self.opts.autoplay && !self.reduced && self.inView) {
            self.ensureLoaded(card, true);
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          }
        } else {
          // pause non-active, but don't interrupt a side card that's mid
          // first-frame paint (it pauses itself once the frame is composited)
          if (!v.dataset.freezing && !v.paused) v.pause();
          v.muted = true;
          var u = card.querySelector('[data-cv-unmute]'); if (u) u.classList.remove('is-on');
        }
      });
    }

    toggleMute(card, btn) {
      var v = card.querySelector('.cv__video');
      if (!v) return;
      v.muted = !v.muted;
      btn.classList.toggle('is-on', !v.muted);
      if (!v.muted) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
    }

    observe() {
      var self = this;
      this._io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          self.inView = en.isIntersecting;
          if (en.isIntersecting) { self.playActive(); self.startAuto(); }
          else {
            var v = self.cards[self.active].querySelector('.cv__video');
            if (v) v.pause();
            self.stopAuto();
          }
        });
      }, { threshold: 0.25 });
      this._io.observe(this);
    }

    startAuto() {
      if (!this.opts.autorotate || this.reduced || !this.inView) return;
      this.stopAuto();
      var self = this;
      this._timer = setInterval(function () { self.go(1); }, this.opts.interval);
    }
    stopAuto() { if (this._timer) { clearInterval(this._timer); this._timer = null; } }

    announce() {
      if (!this.live) return;
      var card = this.cards[this.active];
      var t = card.querySelector('.cv__card-title');
      this.live.textContent = 'Slide ' + (this.active + 1) + ' of ' + this.n + (t ? ': ' + t.textContent : '');
    }
  }

  if (!customElements.get('coverflow-video')) {
    customElements.define('coverflow-video', CoverflowVideo);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
